import { Helmet } from "react-helmet-async";
import FunnelLayout from "@/v2/components/FunnelLayout";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Progetto Startup</title>
        <meta name="description" content="Privacy Policy di Progetto Startup - Come trattiamo i tuoi dati personali in conformità al GDPR" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <FunnelLayout>
        <div className="max-w-3xl mx-auto">
          <article className="prose prose-invert max-w-none text-slate-300">
            <h1 className="text-white text-4xl font-bold mb-2">Privacy Policy</h1>
            <p className="text-slate-500 mb-8">Ultimo aggiornamento: Luglio 2026</p>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Titolare del Trattamento</h2>
              <p className="mb-2"><strong>Federico Piccinini Group</strong></p>
              <p className="mb-2">REA: 226475</p>
              <p className="mb-2">Email: <a href="mailto:ciao@progettostartup.com" className="text-orange-400 hover:text-orange-300">ciao@progettostartup.com</a></p>
              <p>Italia</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Quali dati raccogliamo</h2>
              <ul className="space-y-2">
                <li>Nome e cognome</li>
                <li>Email</li>
                <li>Password (cifrata tramite Supabase Auth)</li>
                <li>Risposte al Reality Check (idea, target, rischio principale, esperimento)</li>
                <li>Dati Sprint (step completati, submission, link a esperimenti)</li>
                <li>Dati di pagamento (gestiti da Stripe — non archiviamo dati carta)</li>
                <li>Preferenze cookie</li>
                <li>Dati tecnici (IP parziale, browser, dispositivo)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Finalità del trattamento</h2>
              <ul className="space-y-2">
                <li>Erogazione dei servizi (registrazione, Reality Check, Sprint 48h)</li>
                <li>Comunicazioni di servizio (email transazionali via Resend)</li>
                <li>Analisi statistiche (solo con consenso)</li>
                <li>Newsletter e promozioni (solo con consenso)</li>
                <li>Prevenzione frodi e sicurezza</li>
                <li>Rispetto obblighi legali</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Base giuridica</h2>
              <ul className="space-y-2">
                <li>Consenso</li>
                <li>Contratto / esecuzione di misure precontrattuali</li>
                <li>Legittimo interesse (sicurezza)</li>
                <li>Obbligo legale</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Conservazione dei dati</h2>
              <ul className="space-y-2">
                <li><strong>Account e dati Sprint:</strong> fino alla cancellazione dell'account</li>
                <li><strong>Newsletter:</strong> fino a revoca del consenso</li>
                <li><strong>Cookie:</strong> secondo durata definita nel banner</li>
                <li><strong>Log di sicurezza:</strong> 6–12 mesi</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Con chi condividiamo i dati</h2>
              <ul className="space-y-2">
                <li>Supabase (database e autenticazione, UE/USA con SCC)</li>
                <li>Stripe (gestione pagamenti)</li>
                <li>Resend (email transazionali)</li>
                <li>Analytics (Google Analytics — solo con consenso)</li>
              </ul>
              <p className="mt-4 font-semibold">Non vendiamo mai i tuoi dati.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Trasferimenti extra-UE</h2>
              <p>Alcuni fornitori potrebbero trovarsi fuori dall'UE, ma sono garantiti da Clausole Contrattuali Standard (SCC).</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">Diritti dell'utente</h2>
              <ul className="space-y-2">
                <li>Accesso ai dati</li>
                <li>Rettifica</li>
                <li>Cancellazione ("diritto all'oblio")</li>
                <li>Limitazione</li>
                <li>Portabilità</li>
                <li>Revoca del consenso</li>
                <li>Reclamo al Garante Privacy</li>
              </ul>
              <p className="mt-4">
                <strong>Richieste:</strong> <a href="mailto:ciao@progettostartup.com" className="text-orange-400 hover:text-orange-300">ciao@progettostartup.com</a>
              </p>
            </section>
          </article>
        </div>
      </FunnelLayout>
    </>
  );
};

export default PrivacyPolicy;
